import React, { useEffect, useState } from 'react';
import { arrayOf, shape, } from 'prop-types';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MediaThumbnail from '../../MediaThumbnail';
import Modal from '../../Modal';

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 1.5rem;


  @media screen and (min-width: 576px) {
    grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
    grid-auto-rows: 1fr;
  }

  @media screen and (min-width: 1400px) {
    grid-template-columns: repeat(6, 1fr);
  }
`;

const TitleWrapper = styled.div`
  display: grid;
  grid-template-columns: 14px 1fr;
  column-gap: 8px;
  margin-bottom: 16px;

  svg {
    margin-top: 3px;
  }

  span {
    line-height: 1.4;
  }
`;

const Item = styled.div`
  background-color: ${({theme}) => theme.colors.white};
  box-shadow: 0 0 2px 0 rgb(0 0 0 / 25%);
  transition: all 0.5s ease;

  &:hover {
    cursor: pointer;
    background-color: ${({theme}) => theme.colors.bg_gray_light};
    box-shadow: 0 0 20px rgb(34 36 38 / 15%);

    ${TitleWrapper} {
      color: ${({theme}) => theme.colors.information};
    }
  }

  img {
    object-fit: cover;
    height: 150px;
  }
`;

const ItemContent = styled.div`
  padding: 1em;
  font-weight: bold;
  white-space: pre-wrap;

  overflow-wrap: break-word;

  word-wrap: break-word;

  word-break: break-word;

  hyphens: auto;
`;

// TODO
// - fix icons, tags, types
const MediaModal = ({items}) => {
  const [isOpen, setOpen] = useState(false);
  const navigate = useNavigate();

  const getIconStr = type => {
    switch(type) {
      case 'panorama':
        return 'street-view';
      case 'video':
        return 'video';
      case 'forest':
        return 'tree';
      case 'forestMulti':
        return 'tree';
      case 'forestRGB':
        return 'tree';
      case 'mill':
        return 'industry';
      default:
        return 'images';
    }
  }

  useEffect(() => {
    if (items.length > 0) {
      setOpen(true);
    }
  }, [items]);

  return (
    <Modal
      isOpen={isOpen}
      size="lg"
      title="Captured multimedia in this location"
      cancelBtnLabel="Close"
      onClose={() => setOpen(false)}
      onlyCloseBtn
      >
       <Grid>
        {items.map(({id, type, name}) => (
          <Item key={id} onClick={() => navigate(`/project/detail/${id}`)} raised>
            <MediaThumbnail id={id} type={type} />
            <ItemContent>
              <TitleWrapper>
                <FontAwesomeIcon icon={['fal', getIconStr(type)]} />
                <span>{name || '-'}</span>
              </TitleWrapper>
            </ItemContent>
          </Item>
        ))}
      </Grid>
    </Modal>
  )
};

MediaModal.propTypes = {
  items: arrayOf(shape({})).isRequired,
}

export default MediaModal;

